import TemplateView from '../../../../../../js/TemplateView'
import {getTextForUserSelectionDescription, isUserSelectionEmpty} from '../../../utils'
import {getInstance as usersSelectionInfo} from '../usersDetailedInfo/UsersSelectionDetailedInfo'

export default class FeedUserSelection extends TemplateView {

    constructor({
            extraClass = '',
            userSelection: {
                all,
                groups,
                users,
                groupType,
            },
            shared = false,
        }
    ) {
        super()

        this.params = {
            extraClass,
            all,
            groups,
            users,
            groupType,
            shared,
        }
    }

    templateHtml() {
        return `<div class='<%=extraClass%> userSelectionList'>
                        <div class='sharedIcon'/>
                        <div class='usersButton'>
                            <span class='text'/>
                        </div>
                </div>`
    }

    templateModel() {
        return {
            extraClass: this.params.extraClass,
        }
    }

    afterRender() {
        const $usersArea = this.find('.usersButton')
        const $usersText = $usersArea.find('.text')

        if (isUserSelectionEmpty(this.params)) {
            $usersText.toggleClass('emptySelection', true)
        }

        const userSelectionText = getTextForUserSelectionDescription({
                all: this.params.all,
                groups: this.params.groups,
                users: this.params.users,
                groupType: this.params.groupType,
            }, this.params.shared
               ? 'icalendar.page.table.user_selection.shared.none'
               : 'icalendar.page.table.user_selection.none'
        )
        $usersText.text(userSelectionText)

        if (!this.params.all &&
            (this.params.groups.length + this.params.users.length > 1)) {
            this.getEl().toggleClass('active', true)

            $usersText.on('click', () => {
                usersSelectionInfo().setState({
                    titleKey: this.params.shared ?
                              'icalendar.page.table.users.shared.detailedInfo.title'
                                                 : 'icalendar.page.table.users.detailedInfo.title',
                    groups: this.params.groups,
                    users: this.params.users,
                    groupType: this.params.groupType,
                })
                usersSelectionInfo().showAt($usersText)
            })
        } else if (!this.params.all && (
            this.params.groups.length + this.params.users.length === 1)) {
            $usersText.prop('title', userSelectionText)
        }
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/cells/FeedUserSelection.js